import React from 'react';
import PropTypes from 'prop-types';
import AdSense from './AdSense';

/**
 * AdRectangle Component
 * 
 * A medium rectangle ad (typically 300x250 pixels)
 * Commonly used in sidebars and within content
 * 
 * @param {Object} props Component props
 * @param {string} props.adSlot The ad unit ID
 * @param {Object} props.style Additional inline styles
 * @param {string} props.className Additional CSS classes
 */
const AdRectangle = ({ adSlot, style, className }) => {
  const rectangleStyle = {
    width: '300px',
    height: '250px',
    maxWidth: '100%',
    ...style
  };
  
  return (
    <AdSense
      adSlot={adSlot}
      adFormat="rectangle"
      style={rectangleStyle}
      className={`ad-rectangle ${className || ''}`}
    />
  );
};

AdRectangle.propTypes = {
  adSlot: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

AdRectangle.defaultProps = {
  adSlot: 'rectangle-ad-slot',
  style: {},
  className: ''
};

export default AdRectangle; 